<template>
  <div class="card content-card shadow">
    <div class="card-body p-4">
      <slot name="title">
        <h4 v-if="title" class="mb-3">{{ title }}</h4>
      </slot>

      <div class="card-text">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String
  }
};
</script>

<style>
.content-card + .content-card {
  margin-top: 2rem !important;
}
</style>
